$(() => {

    if($('.switch-box .switch').length > 0) {
        setupSwitch();
    }
    
});

function setupSwitch() {

    $('.switch-box .switch-input').on('change', (event) => {
        const checkbox = $(event.target);
        const container = checkbox.closest('.switch');

        const isChecked = checkbox.prop('checked');

        switchValues(container);

        if(isChecked) { container.addClass('is-checked'); }
        else { container.removeClass('is-checked'); }

        if(checkbox.data('ajaxlink') !== '') 
        {
            sendAjax(checkbox);
        }

    });

    function sendAjax(checkbox) {

        const url = checkbox.data('ajaxlink');
        const postData = {'isChecked': checkbox.prop('checked')}

        $.post(
            url, 
            postData, 
            (data) => {
                if(data.success) 
                {
                    const switchFunction = window['switch' + data.switch];
                    
                    if(switchFunction !== undefined) { switchFunction(data.isChecked); }
                }
            }
        );
    }

    function switchValues(container) {

        const valueContainer = $(container.find('.toggle-value'));
        
        const oldValue = valueContainer.text();
        const newValue = valueContainer.data('othervalue');

        valueContainer.text(newValue);
        valueContainer.data('othervalue', oldValue);
    }
}


function switchDarkmode(isActive = 0) 
{
    if(isActive) {
        $('html').addClass('darkmode');
        $('#non-darkmode-dash-map').addClass('display-none');
        $('#darkmode-dash-map').removeClass('display-none');
    }
    else {
        $('html').removeClass('darkmode');
        $('#non-darkmode-dash-map').removeClass('display-none');
        $('#darkmode-dash-map').addClass('display-none');
    }
}